import BpkText, {
  TEXT_COLORS,
} from '@skyscanner/backpack-web/bpk-component-text';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import PopularDestination from '../PopularDestination';
import RecentSearches from '../RecentSearches';

import type { PopularDestination as PopularDestinationType } from '../../../types';
import type { I18nService } from '@shared/types/i18n';

import STYLES from './RecentSearchAndPopulars.module.scss';

import { withI18n } from '@shared/ui/contexts/i18n';

type Props = {
  i18n: I18nService;
  suggestion: PopularDestinationType;
  onSuggestionSelected: Function;
  onSuggestionsClearRequested: Function;
  onBlur: Function;
};

const cls = cssModules(STYLES);

const RecentSearchAndPopulars = ({
  i18n: { translate },
  onBlur,
  onSuggestionSelected,
  onSuggestionsClearRequested,
  suggestion,
}: Props) => {
  const hasPopular =
    suggestion.popularDestinations && suggestion.popularDestinations.length > 0;
  return (
    <section className={cls('RecentSearchAndPopulars')}>
      <RecentSearches
        onSuggestionSelected={onSuggestionSelected}
        onSuggestionsClearRequested={onSuggestionsClearRequested}
        onBlur={onBlur}
      />
      {hasPopular && (
        <section>
          <BpkText
            tagName="p"
            className={cls('RecentSearchAndPopulars__popularTitle')}
            color={TEXT_COLORS.textPrimary}
          >
            {translate('Auto_Suggest_popularDestination_label')}
          </BpkText>
          <div className={cls('RecentSearchAndPopulars__popularDestinations')}>
            {suggestion.popularDestinations &&
              suggestion.popularDestinations.map((popular, index) => (
                <PopularDestination
                  key={popular.entityId}
                  popular={popular}
                  index={index}
                  onSuggestionSelected={onSuggestionSelected}
                  onBlur={onBlur}
                  onSuggestionsClearRequested={onSuggestionsClearRequested}
                />
              ))}
          </div>
        </section>
      )}
    </section>
  );
};

export default withI18n(RecentSearchAndPopulars);
